import { SaasEvent } from "../shared/saasTypes";
import { categoryLabel, formatDateTime } from "../shared/saasFormat";
import { MetaTag, RiskBadge } from "../shared/SaasUi";

export default function EventList({ events, onOpen, emptyLabel = "No events recorded" }: {
    events: SaasEvent[];
    onOpen: (eventId: number) => void;
    emptyLabel?: string;
}) {
    if (events.length === 0) {
        return <p className="text-sm text-muted-foreground py-6 text-center">{emptyLabel}</p>;
    }
    return (
        <div className="space-y-1.5">
            {events.map((event) => (
                <button
                    key={event.id}
                    type="button"
                    onClick={() => onOpen(event.id)}
                    className="w-full text-left rounded-xl border border-border bg-card px-3 py-2 portal-card-hover"
                >
                    <div className="flex items-center gap-2 flex-wrap">
                        <span className="text-xs font-semibold font-mono truncate">{event.action}</span>
                        <RiskBadge level={event.riskLevel && event.riskLevel !== "INFO" ? event.riskLevel : null} />
                        {event.category && <MetaTag>{categoryLabel(event.category)}</MetaTag>}
                        <span className="ml-auto text-[11px] text-muted-foreground whitespace-nowrap">{formatDateTime(event.occurredAt)}</span>
                    </div>
                    {event.summary && <p className="text-xs text-muted-foreground mt-1 truncate" title={event.summary}>{event.summary}</p>}
                </button>
            ))}
        </div>
    );
}
